export async function MountDonut(props: any, el: HTMLElement) {
	const a = await import('./chart');
	a.MountDonut(props, el);
}

(window as any).MountDonut = MountDonut;
